
function reducer( state = { settings: false, site_options: false }, action ) {
	switch ( action.type ) {
		case 'SET_SETTINGS':
			if ( ! state.settings && action.settings ) {
				state.settings = action.settings;
			}
			break;
		case 'SET_SITE_OPTIONS':
			if ( ! state.site_options && action.site_options ) {
				state.site_options = { ...action.site_options };
			}
			break;
		case 'UPDATE_SITE_OPTIONS':
			if ( action.site_options ) {
				state.site_options = { ...action.site_options };
			}
			break;
	// no default
	}

	return { ...state };
}

export default reducer;
